module.exports = __webpack_public_path__ + "media/img/referrals/grid-1158c5566903b5809fe739e278f0094b.png";